import React from "react";
import "./About.css";

export default function About() {
  return (
    <div className="about-page">
      {/* ── Hero banner ── */}
      <section className="about-hero-banner">
        <div className="about-hero-overlay" />
        <div className="about-hero-text">
          <span className="section-label">Our Story</span>
          <h1>We are Proudly Pahadi.<br/>And to us, Pahadi means pure.</h1>
        </div>
      </section>

      {/* ── Letter from Uttarakhand ── */}
      <section className="about-letter">
        <div className="about-letter-inner">
          <p className="about-letter-greeting">A note from the mountains —</p>
          <p>
            In the hills of Uttarakhand, purity isn't a marketing word.
            It's a way of life. Pahadi families have eaten close to the earth
            for generations. No shortcuts. No additives. No compromise.
          </p>
          <p>
            <strong>PureJar was born from that same belief.</strong>
          </p>
          <p>
            We source only what passes our quality standard — not a marketing
            checklist, but a <em>real test</em>. Every product we carry has been
            tasted, evaluated, and approved before it reaches your door.
            If it doesn't meet our standard, it doesn't carry our name.
          </p>
          <p>
            We started in the mountains of Uttarakhand. We will source from
            wherever India's finest ingredients grow. But we will always hold
            every product to the Pahadi standard —
          </p>
          <p className="about-letter-highlight">
            Pure by nature, pure by culture.
          </p>
          <p>
            That's what Proudly Pahadi means to us.<br/>
            And that's the promise in every jar.
          </p>
          <p className="about-letter-sign">
            — From Uttarakhand, <em>Proudly Pahadi</em>
          </p>
        </div>
      </section>

      {/* ── Product collection band ── */}
      <section className="about-collection">
        <img src="/images/about-collection.jpg" alt="PureJar product collection" />
      </section>

      <section className="about-values">
        <div className="value"><h3>Quality Tested</h3><p>Every product is tasted and evaluated before it carries our name.</p></div>
        <div className="value"><h3>Customer Obsessed</h3><p>We'd rather say no to a product than compromise on what you eat.</p></div>
        <div className="value"><h3>Pahadi Standard</h3><p>Pure by nature, pure by culture — the standard we hold everything to.</p></div>
      </section>

      {/* ── Lifestyle band ── */}
      <section className="about-lifestyle">
        <div className="about-lifestyle-img">
          <img src="/images/about-turmeric-lifestyle.jpg" alt="Himalayan turmeric on rustic wood" />
        </div>
        <div className="about-lifestyle-text">
          <h2>The Pahadi standard</h2>
          <p>
            Pahadi people have always lived close to the earth. Their food is
            unprocessed, their ingredients wild-grown, their relationship with
            food honest. We source like a Pahadi would — only the best, only
            the pure, nothing artificial.
          </p>
        </div>
      </section>

      <section className="about-legal">
        <p>PureJar — A venture of Neoteric Roots Private Limited, Uttarakhand.</p>
        <p className="legal-ids">
          GST: 05AAJCN1056D1ZU · FSSAI: 22624038000343 · CIN: U82990UT2023PTC016158
        </p>
        <p>Questions? Write to us at <a href="mailto:wecare@purejar.in">wecare@purejar.in</a></p>
      </section>
    </div>
  );
}